import $ from 'jquery';
import uuid from 'uuid/v1';

class BaseComponent {
    constructor(selector) {
        this.id = uuid();
        this.selector = selector;
        this.$el = $(this.selector);

        this.mount();
    }

    mount() {}

    unmount() {}

    $(sel) {
        return this.$el.find(sel);
    }

    // Events API
    // =========================================================

    on(...args) {
        this.$el.on(...args);
    }

    off(...args) {
        this.$el.off(...args);
    }

    trigger(...args) {
        this.$el.trigger(...args);
    }
}

export default BaseComponent;
